import React, { useEffect, useState } from "react";
import { BookOpen, Download, Mail, Gift, UserMinus } from "lucide-react";
import api from "@/lib/api";

const fmtWeek = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { day: "numeric", month: "short" });

export default function GuideStatsCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/guide-stats?weeks=8").then(({ data }) => setData(data)).catch(() => setData(null)); }, []);
  if (!data) return null;
  const { weeks, totals } = data;
  const max = Math.max(1, ...weeks.map((w) => Math.max(w.requests, w.downloads)));
  const stat = (icon, label, value, testid) => (
    <div className="rounded-2xl bg-[#FFF9EE] px-4 py-3 min-w-[120px]" data-testid={testid}>
      <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-bold text-[#19324A]/55">{icon}{label}</div>
      <p className="font-display font-extrabold text-2xl text-[#19324A] mt-0.5">{value}</p>
    </div>
  );
  return (
    <div className="bg-white rounded-3xl soft-shadow p-5 mb-6" data-testid="guide-stats-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h3 className="font-display font-extrabold text-xl text-[#19324A] flex items-center gap-2"><BookOpen className="w-5 h-5 text-[#4CC9F0]" /> Free Bulldog Guide</h3>
          <p className="text-xs text-[#19324A]/55 mt-0.5">Who's grabbing the guide each week — and how the welcome treat is landing.</p>
        </div>
        <div className="flex gap-3 text-[11px] font-bold text-[#19324A]/60">
          <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm bg-[#FF6B9D]" /> Emailed</span>
          <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm bg-[#4CC9F0]" /> Downloaded</span>
        </div>
      </div>
      <div className="flex flex-wrap gap-3 mt-4">
        {stat(<Mail className="w-3.5 h-3.5" />, "Emailed", totals.requests, "guide-stat-requests")}
        {stat(<Download className="w-3.5 h-3.5" />, "Downloads", totals.downloads, "guide-stat-downloads")}
        {stat(<Gift className="w-3.5 h-3.5" />, "Treats sent", totals.welcome_sent, "guide-stat-welcome")}
        {stat(<Gift className="w-3.5 h-3.5" />, "Redeemed", totals.welcome_redeemed, "guide-stat-redeemed")}
        {stat(<UserMinus className="w-3.5 h-3.5" />, "Unsubscribed", totals.unsubscribed, "guide-stat-unsub")}
      </div>
      <div className="mt-5 grid gap-2" style={{ gridTemplateColumns: `repeat(${weeks.length}, minmax(0, 1fr))` }} data-testid="guide-stats-chart">
        {weeks.map((w) => (
          <div key={w.week} className="flex flex-col items-center gap-1" data-testid={`guide-week-${w.week}`}>
            <div className="flex items-end gap-1 h-24 w-full justify-center">
              <div className="w-3 sm:w-4 rounded-t-md bg-[#FF6B9D] transition-[height]" style={{ height: `${(w.requests / max) * 100}%`, minHeight: w.requests ? 4 : 0 }} title={`${w.requests} emailed`} />
              <div className="w-3 sm:w-4 rounded-t-md bg-[#4CC9F0] transition-[height]" style={{ height: `${(w.downloads / max) * 100}%`, minHeight: w.downloads ? 4 : 0 }} title={`${w.downloads} downloads`} />
            </div>
            <span className="text-[10px] text-[#19324A]/55 font-semibold">{fmtWeek(w.week)}</span>
            <span className="text-[10px] text-[#19324A]/40">{w.requests + w.downloads || ""}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
